import { Link } from 'react-router-dom';
import { useState } from 'react';

const footerLinks = {
  '热门分类': [
    { label: '网红黑料', path: '/category/wanghong' },
    { label: '明星八卦', path: '/category/mingxing' },
    { label: '热门吃瓜', path: '/category/remen' },
  ],
  '关于平台': [
    { label: '关于我们', path: '/about' },
    { label: '联系方式', path: '/about#contact' },
    { label: '品牌介绍', path: '/about#brand' },
  ],
  '帮助中心': [
    { label: '常见问题', path: '/about#faq' },
    { label: '使用指南', path: '/about#guide' },
    { label: '举报反馈', path: '/about#report' },
  ],
  '友情链接': [
    { label: '吃瓜视频在线', path: '/' },
    { label: '国产吃瓜视频', path: '/category/guochan' },
    { label: '吃瓜视频APP', path: '/about#app' },
  ],
};

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subStatus, setSubStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [subMessage, setSubMessage] = useState('');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubStatus('loading');

    try {
      const formData = new FormData();
      formData.append('email', email);

      const response = await fetch('https://form.readdy.ai/api/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email, source: 'footer-subscribe' }).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setSubStatus('success');
        setSubMessage('订阅成功！我们会及时推送最新吃瓜内容。');
        setEmail('');
      } else {
        setSubStatus('error');
        setSubMessage(parsed?.meta?.message || '订阅失败，请稍后重试');
      }
    } catch {
      setSubStatus('error');
      setSubMessage('网络错误，请检查连接后重试');
    }
  };

  return (
    <footer className="bg-accent-900 text-white/90">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-5">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="text-white text-sm font-bold">🍉</span>
              </div>
              <span className="text-xl font-bold text-white">吃瓜视频</span>
            </div>

            <form onSubmit={handleSubscribe} className="flex items-center gap-0 mb-6 max-w-sm">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入邮箱订阅最新吃瓜"
                className="flex-1 h-11 px-4 rounded-l-lg bg-white/10 border border-white/20 text-sm text-white placeholder-white/40 outline-none focus:border-white/40 transition-colors"
                required
              />
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="absolute left-[-9999px] opacity-0 h-0 w-0 pointer-events-none"
              />
              <button
                type="submit"
                disabled={subStatus === 'loading'}
                className="h-11 px-4 rounded-r-lg bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm cursor-pointer transition-colors whitespace-nowrap disabled:opacity-60"
              >
                {subStatus === 'loading' ? (
                  <i className="ri-loader-4-line animate-spin"></i>
                ) : (
                  <i className="ri-notification-3-line text-lg"></i>
                )}
              </button>
            </form>

            {subStatus !== 'idle' && (
              <p className={`text-xs mb-4 ${subStatus === 'success' ? 'text-green-300' : 'text-red-300'}`}>
                {subMessage}
              </p>
            )}

            <p className="text-2xl font-heading text-white leading-relaxed">
              每日更新 <span className="text-primary-400">网红黑料</span>
              <br />
              实时追踪 <span className="text-primary-400">明星塌房</span>
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-white mb-4">{title}</h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-white/60 hover:text-white/90 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50">
            &copy; {new Date().getFullYear()} 吃瓜视频 nexkinn.cn 版权所有
          </p>
          <div className="flex items-center gap-4">
            {['ri-wechat-line', 'ri-weibo-line', 'ri-bilibili-line', 'ri-tiktok-line'].map((icon) => (
              <a
                key={icon}
                href="#"
                rel="nofollow"
                className="w-8 h-8 flex items-center justify-center rounded-lg border border-white/20 text-white/60 hover:text-white hover:border-white/40 transition-all cursor-pointer"
                aria-label="社交媒体"
              >
                <i className={`${icon} text-sm`}></i>
              </a>
            ))}
          </div>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-white/40 hover:text-white/70 transition-colors cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-white/40 hover:text-white/70 transition-colors cursor-pointer" rel="nofollow">
              用户协议
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}